<template>
  <button
    class="LmVoteButton"
    :class="{'is-selected': state}"
    @click="$emit('click', $event)"
  >
    <lm-material-icon class="Icon" icon="arrow_drop_up" />
    <span class="Votes">{{ votes }}</span>
  </button>
</template>

<script>
import LmMaterialIcon from '@/components/ui/LmMaterialIcon'
export default {
  name: 'LmVoteButton',
  components: {LmMaterialIcon},
  props: {
    votes: {
      type: Number,
      default: 0
    },
    state: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.LmVoteButton {
  display: flex;
  align-items: center;
  width: 52px;
  height: 32px;
  padding: 1px 6px;
  border: 1px solid theme('colors.gray.300');
  color: theme('colors.gray.500');
  background-color: white;
  cursor: pointer;
  font-size: 12px;
  &:hover {
    color: theme('colors.gray.700');
    border-color: theme('colors.gray.500');
  }
  &.is-selected {
    border-color: theme('colors.gray.900');
    .Icon,
    .Votes {
      color: theme('colors.gray.900');
    }
  }
}
</style>
<style>
.js-focus-visible .LmVoteButton:focus:not(.focus-visible) {
  outline: none;
}
</style>
